<div class="ic-list-column-header no-select"
     [class.sortable]="sortable"
     (click)="sort()"
     data-testId="container">

    <ng-content></ng-content>

    <div class="indicator" *ngIf="sortable">
        <mat-icon [class.active]="isSortedOnce && !isAsc"
                  [hidden]="isSortedOnce && isAsc">arrow_drop_up
        </mat-icon>
        <mat-icon [class.active]="isSortedOnce && isAsc"
                  [hidden]="isSortedOnce && !isAsc">arrow_drop_down
        </mat-icon>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/list/column.header/list.column.header.component.html